import React, { PropTypes } from 'react'
import FacebookProvider, { Login } from 'react-facebook'


class FacebookLoginButton extends React.Component {
  render () {
    return (
        <FacebookProvider appId={this.props.appId}>
          <Login scope="public_profile,email,"
                fields={['id', 'first_name', 'last_name', 'middle_name', 'age_range', 'picture',
                          'name', 'email', 'locale', 'gender', 'timezone', 'verified', 'link']}
                onError = {(error) => {
                }}
                onResponse={(data) => {
                  if (!data) {
                    return
                  }
                  this.props.doFBLogin({
                    access_token: data.tokenDetail.accessToken,
                    profile: {...data.profile}
                  }
            )}}>
            <a onClick={(e) => {e.preventDefault(); return false; }} className="button join-facebookButton" href="#">
              <i className="fa fa-facebook"></i> Continue with Facebook
            </a>
          </Login>
        </FacebookProvider>
    )
  }
}

export default FacebookLoginButton



// WEBPACK FOOTER //
// ./src/components/FacebookLoginButton.jsx